import React from 'react';

import { IIconProps } from 'ui/CircleIconButton';
import { theme } from '../../../../tailwind.config';

export const NotificationCurrencySign: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['gray-40'], background = theme.colors['white'] }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 3H3C2.1675 3 1.5075 3.6675 1.5075 4.5L1.5 13.5C1.5 14.3325 2.1675 15 3 15H15C15.8325 15 16.5 14.3325 16.5 13.5V4.5C16.5 3.6675 15.8325 3 15 3ZM8.25 12.75H9.75V12H10.5C10.9125 12 11.25 11.6625 11.25 11.25V9C11.25 8.5875 10.9125 8.25 10.5 8.25H8.25V7.5H11.25V6H9.75V5.25H8.25V6H7.5C7.0875 6 6.75 6.3375 6.75 6.75V9C6.75 9.4125 7.0875 9.75 7.5 9.75H9.75V10.5H6.75V12H8.25V12.75ZM3 13.5H15V4.5H3V13.5Z"
        fill={fill}
      />
    </svg>
  )
);
